import * as angular from 'angular';

import { ComponentDefinition, Log } from '../../../../models';
import { mostFrequentMessages } from './mostFrequentMessages';

class TableByMessageCountController implements angular.IComponentController {
    table: any[];

    readonly logs: Log[];

    static $inject = [];

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['logs']?.currentValue) {
            this.table = mostFrequentMessages(this.logs);
        }
    }
}

export const wtTableByMessageCount: ComponentDefinition = {
    componentId: 'wtTableByMessageCount',
    controller: TableByMessageCountController,
    template: require('./tableByMessageCount.component.html'),
    controllerAs: 'vm',
    bindings: {
        logs: '<'
    }
};
